import React from 'react'
import { Outlet, Navigate, useLocation } from "react-router-dom";

const RequireAuth = () => {

    // The JWT is stored in an httpOnly cookie (httpOnly: true) and cannot be
    // read from JavaScript. The backend validates the cookie on every request.
    // Here we only check the non-sensitive userId we stored after login.
    const userId = localStorage.getItem('userId');

    const location = useLocation();

  return (
    userId ? <Outlet /> : <Navigate to="/login" state = {{from: location}} />
  )
}

export default RequireAuth